import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";

import { environment } from "../../environments/environment";

import { Md5 } from "ts-md5/dist/md5"

@Injectable({ providedIn: "root" })
export class UserService {
    constructor(private http: HttpClient) { }

    getStudentDetails(studentRegistrationId: number) {
        return this.http.get(`${environment.apiUrl}/PortalStudent/GetStudentDetails?studentRegistrationId=${studentRegistrationId}`);
    }

    getStudentRegistrationsByName(firstName: string, lastName: string) {
        return this.http.get(`${environment.apiUrl}/PortalStudent/GetStudentRegistrationsByName?firstName=${firstName}&lastName=${lastName}`);
    }

    getStudentRegistrationsByProgramCode(firstName: string, lastName: string, email: string, dateOfBirth: string, programCode: string) {
        return this.http.get(`${environment.apiUrl}/PortalStudent/GetStudentRegistrationsByProgramCode?firstName=${firstName}&lastName=${lastName}&email=${email}&dateOfBirth=${dateOfBirth}&programCode=${programCode}`);
    }

    register(registrationData: any) {
        return this.http.post(`${environment.apiUrl}/PortalStudent/Register`, registrationData);
    }

    verify(verificationCode: string) {
        return this.http.get(`${environment.apiUrl}/PortalStudent/VerifyStudent?verificationCode=${verificationCode}`);
    }

    updateStudentDetails(userData: any) {
        return this.http.post(`${environment.apiUrl}/PortalStudent/UpdateStudentDetails`, userData);
    }

    forgotPassword(studentEmail: string) {
        const data = {
            studentEmail: studentEmail
        };

        return this.http.post(`${environment.apiUrl}/PortalStudent/GetChangePasswordLink`, data);
    }

    resetPassword(password: string, confirmPassword: string, resetPasswordGuid: string) {
        const data = {
            password: Md5.hashStr(password),
            confirmPassword: Md5.hashStr(confirmPassword),
            resetPasswordGuid: resetPasswordGuid
        };

        return this.http.post(`${environment.apiUrl}/PortalStudent/ResetPassword`, data);
    }

    changePassword(studentRegistrationId: number, password: string, newPassword: string, confirmPassword: string) {
        const data = {
            studentRegistrationId: studentRegistrationId,
            oldPassword: Md5.hashStr(password),
            newPassword: Md5.hashStr(newPassword),
            confirmPassword: Md5.hashStr(confirmPassword)
        };

        return this.http.post(`${environment.apiUrl}/PortalStudent/ChangePassword`, data);
    }

    getStudentImage(studentCode: string, attachmentId?: number) {
        const params = new HttpParams().set("attachmentId", String(attachmentId)).set("studentCode", studentCode);

        return this.http.get(`${environment.apiUrl}/PortalStudent/GetStudentImage`, {params: params});
    }

    logout(studentLoginId: number, studentRegistrationId: number, isSessionTimeout: boolean) {
        const data = {
            studentRegistrationId: studentRegistrationId,
            studentLoginId: studentLoginId,
            isSessionTimeout: isSessionTimeout
        };

        return this.http.post(`${environment.apiUrl}/PortalStudent/Logout`, data);
    }

    openAttachment(attachmentId: number) {
        const httpOptions = {
            'responseType': "arraybuffer" as "json"
        };

        return this.http.get<any>(`${environment.apiUrl}/PortalStudent/OpenAttachment?attachmentId=${attachmentId}`, httpOptions);
    }

    syncStudentData(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalStudent/SyncStudentData`, saveModel);
    }
}